module.exports = __webpack_public_path__ + "static/media/logo-leclerc-mobile.bcdb3339.svg";